import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import lockScreenIllustration from 'assets/images/banners/PushDisabledBanner/img_lockscreen.svg'
import Lock from 'components/Icons/Lock'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import ContactSupportLink from './ContactSupportLink'

const t = buildTranslate('live_updates.push_disabled')

const BANNER_PADDING = '16px'
const BANNER_RADIUS = '4px'
const BANNER_GAP = '16px'
const TEXT_GAP = '4px'
// Figma 1980:39579: the lock icon sits inline with the title only — the
// subtitle and link are full-width lines below, flush with the icon's left
// edge rather than indented under the title.
const ICON_TITLE_GAP = '8px'
// Figma 1980:39592 — the lock-screen illustration is designed to bleed past
// the banner's own bottom padding and get clipped flush by the banner's
// rounded corners, so it's pulled down by the padding amount rather than
// sitting inside it like the icon/text column.
const ILLUSTRATION_WIDTH = '130px'
const ILLUSTRATION_HEIGHT = '97px'
// Figma 1980:39592 sits the illustration well clear of the banner's right
// edge (unlike the bottom, which it bleeds flush against) — extra margin on
// top of the banner's own padding.
const ILLUSTRATION_RIGHT_MARGIN = '40px'

const PushDisabledBanner = () => {
  const [css] = useStyletron()

  return (
    <div
      data-testid="lu-push-disabled-banner"
      className={css({
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: BANNER_GAP,
        padding: BANNER_PADDING,
        borderRadius: BANNER_RADIUS,
        border: `1px solid ${palette.grey20}`,
        backgroundColor: palette.grey10,
      })}
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: TEXT_GAP,
        })}
      >
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            gap: ICON_TITLE_GAP,
          })}
        >
          {/* Lock doesn't set aria-hidden on its own <svg>, unlike ClockArrowUp. */}
          <span
            aria-hidden="true"
            className={css({ display: 'flex', flexShrink: 0 })}
          >
            <Lock fillColor={palette.grey90} />
          </span>
          <Text.Header4 tag="h2" className={css({ margin: 0 })}>
            {t('banner_title')}
          </Text.Header4>
        </div>
        <Text.BodyText4 color="grey70" className={css({ display: 'block' })}>
          {t('body')}
        </Text.BodyText4>
        <ContactSupportLink />
      </div>

      <img
        src={lockScreenIllustration}
        alt=""
        aria-hidden="true"
        className={css({
          flexShrink: 0,
          alignSelf: 'flex-end',
          width: ILLUSTRATION_WIDTH,
          height: ILLUSTRATION_HEIGHT,
          marginBottom: `-${BANNER_PADDING}`,
          marginRight: ILLUSTRATION_RIGHT_MARGIN,
        })}
      />
    </div>
  )
}

export default PushDisabledBanner
